import { DaoService } from "./DaoService";

export class MonnaieService extends DaoService {

    static CLASS_NAME = "App\\Models\\Monnaie";
    
    static getInstance() {
        return super.getInstance('monnaie');
    }

    enable(idOrUid) {
        return MonnaieService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    all() {
        return MonnaieService.get(`${this.prefix}/all`);
    }

    search(data) {
        return MonnaieService.post(`${this.prefix}/search`, data);
    }
    
    getCurrentActive() {
        return MonnaieService.get(`${this.prefix}/current`);
    }

}